module.exports = __webpack_public_path__ + "static/04-1079f1ec9394843e21a7009728d47a38.jpg";